module.exports = __webpack_public_path__ + "assets/collegiatessoutside-regular-webfont-a8ada2b08110b501c6135e6476f25ea4.svg";